/**
* Report Item API Call.
*
* @author Ryan Johnston <ryan.johnston@scalesology.com>
*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import apiConfig from 'js/config/api';
import childrenPropType from 'js/PropTypes/children';
import LoadingIndicator from 'js/Components/LoadingIndicator';
import NetworkAlert from 'js/Components/Alert/NetworkAlert';
import {httpError401} from "js/Components/Api/useHttp";

/**
 * Report Item API Calling Class
 */
class ReportItem extends Component {
    static propTypes = {
        children: childrenPropType,
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        sessionId: PropTypes.string,
        pdf:PropTypes.bool
    };

    static defaultProps = {
        children: null,
        id: null,
        sessionId: null,
        pdf:false
    };

    /**
     * constructor
     *
     * @param {object} props Properties
     *
     * @returns {void}
     */
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            loading: true,
            report: {},
        };

        // Load report from API
       // this.loadReport(props.id);
       this.reloadReport = this.reloadReport.bind(this)
    }

    componentDidMount(){
        this.loadReport(this.props.id);
    }
    
    /**
     * If report id changes, lookup next report.
     *
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {
        const { id } = this.props;

        if (id !== nextProps.id) {
            this.loadReport(nextProps.id);
        }
    }

    /**
     * Load all Persons.
     *
     * @returns {void}
     */
    loadReport(id) {
        const { sessionId } = this.props;

        if (id === null) { // no-op
            return;
        }
        const pdfStr = this.props.pdf?"&pdf=true":''; 
        fetch(
            `${apiConfig}report/${id}?sessionId=${sessionId}${pdfStr}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
            })
            .then((response) => {
                const { status } = response;

                if(status === 401)
                {
                    httpError401();
                }
                else if (status !== 200) {
                    return this.setState({
                        error: true,
                        loading: false,
                        report: {},
                    });
                }

                response
                    .json()
                    .then((body) => {
                        const newState = {};
                        const report = body;

                        newState.report = report;
                        newState.error = false;
                        newState.loading = false;
                        return this.setState(newState);
                    });
            });
    }

    reloadReport(){
        this.loadReport(this.props.id);
    }

    /**
     * Render the report item API call children.
     *
     * @returns {React.node|object}
     */
    render() {
        const { children, ...passThroughProps } = this.props;
        const { error, loading, report } = this.state;

        if (error) {
            return (
                <NetworkAlert
                    label="report"
                />
            );
        }

        if (loading) {
            return (
                <LoadingIndicator
                    label="Loading report info..."
                />
            );
        }

        return React.Children.map(children, (child) => {
            if (child === null || child === undefined) {
                return null;
            }

            if (typeof child === 'string') {
                return child;
            }

            return React.cloneElement(child, {
                report,
                reloadReport:this.reloadReport,
                ...passThroughProps,
            });
        });
    }
}

export default ReportItem;
